import CloseIcon from '@mui/icons-material/Close';
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { Backdrop, Button, CircularProgress, Grid, MenuItem, Select, TextField } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { Box } from '@mui/system';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import * as Yup from "yup";
import pdfIcon from "../../../../images/pdfIcon.png";
import { AllPermissions } from '../../../../network/APIs/APIs';
import { cfpBaseUrl } from '../../../../network/urls';
import { handleFileUpload, isImage, isPdf } from '../../../../services/Functions';
import './RoleUpdateForm.scss';
import { documentExtensions } from '../../../../utils/PortalName';


const RoleUpdateForm = () => {
  const initialValues = {
    iv_roleName: "",
    iv_level: '',
    iv_status: '',
    iv_show_all_applications_flag: null,
    iv_assigning_order_no: '',
    iv_assigning_authority: '',
    iv_assigining_date: '',
    iv_assigining_order_image: ''
  }

  const [status, setStatus] = useState(1);
  const [applicationsAppliedLoadFilter, setApplicationsAppliedLoadFilter] = useState(0);
  const [sortedPermissions, setSortedPermissions] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]);
  const [roleDataById, setRoleDataById] = useState();
  const [orderImage, setOrderImage] = useState()
  const [orderImageError, setOrderImageError] = useState()
  const [orderImageThumbnail, setOrderImageThumbnail] = useState()
  const [viewBackdrop, setViewBackdrop] = React.useState(false);

  const { state } = useLocation();
  const { roleDetails } = state;
  const [isLoadingSpinner, setIsLoadingSpinner] = useState(false);
  const navigate = useNavigate()

  let { token, userId, permissions, hierarchy } = useSelector((state) => state.auth)

  const [technicalLevels, setTechnicalLevels] = useState([{
    value: 1,
    label: 'PITC'
  }, {
    value: 2,
    label: 'DISCO'
  }, {
    value: 3,
    label: 'Circle'
  }, {
    value: 4,
    label: 'Division'
  }, {
    value: 52,
    label: 'Sub Division'
  }])

  useEffect(() => {
    if (hierarchy != 1) {
      let hierarchyArray = technicalLevels
      setTechnicalLevels(hierarchyArray.filter(item => item.value >= parseInt(hierarchy)))
    }
  }, [hierarchy])

  useEffect(() => {
    setRoleDataById(roleDetails);
  }, [])

  const OrderImage = (event) => {
    if (event.target.files) {
      const newFileName = 'orderImage.' + event.target.files[0].name.split(".").pop();
      handleFileUpload(event, handleChange, setOrderImage, setOrderImageError, setOrderImageThumbnail, newFileName);
    }
  }


  useEffect(() => {
    const getAllPermissions = async () => {
      setViewBackdrop(true)
      let { sortedAllPermissions } = await AllPermissions(token, permissions)
      setSortedPermissions(sortedAllPermissions)
      setViewBackdrop(false)
    }
    getAllPermissions()
  }, [])

  function base64toFile(base64String, filename) {
    // Split the base64 string into two parts
    const parts = base64String.split(';base64,');
    const type = parts[0].split(':')[1];
    const byteString = atob(parts[1]);

    // Create a Uint8Array to hold the byte string
    const byteArray = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      byteArray[i] = byteString.charCodeAt(i);
    }

    // Create a Blob from the Uint8Array
    const blob = new Blob([byteArray], { type: type });

    // Create a File object from the Blob
    const file = new File([blob], filename, { type: type });

    return file;
  }


  useEffect(() => {
    const getRoleDetails = async () => {

      if (roleDataById) {
        const rolesHeaders = new Headers();
        rolesHeaders.append("Authorization", token);

        const formdataRoles = new FormData();
        formdataRoles.append("roleId", roleDataById.id);

        const requestOptionsRoles = {
          method: "POST",
          headers: rolesHeaders,
          body: formdataRoles,
          redirect: "follow"
        };

        await fetch(cfpBaseUrl + "role/getLatestPremAsigningOrder", requestOptionsRoles)
          .then((response) => response.json())
          .then((result) => {
            if (result.status === '200') {
              values.iv_assigning_order_no = result.data[0].premAsigningOrderNo
              values.iv_assigning_authority = result.data[0].premAsigningOrderAuthority
              values.iv_assigining_date = result.data[0].premAsigningOrderDate.slice(0, 10);


              setOrderImageThumbnail(result.data[0].premAsigningOrderImage)
              let orderImageFile = base64toFile(result.data[0].premAsigningOrderImage)
              setOrderImage(orderImageFile)
            }
          })
          .catch((error) => console.error(error));


        values.iv_roleName = roleDataById.name
        values.iv_level = roleDataById.level
        values.iv_status = roleDataById.level
        values.iv_show_all_applications_flag = roleDataById.showAllApplicationsFlag


        setStatus(roleDataById.status);
        setApplicationsAppliedLoadFilter(roleDataById.status);
        var formdata = new FormData();
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;
        formdata.append("roleId", roleDataById.id);
        var requestOptions = {
          method: 'POST',
          body: formdata,
          headers: myHeaders,
          redirect: 'follow',
        };
        fetch(cfpBaseUrl + "role/getPremRole", requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.status === "200") {
              let responseArray = result.data;
              let permissionsArray = []
              responseArray.forEach((item) => {
                permissionsArray.push(item.perm_id)
              })
              setCheckedItems(permissionsArray)
            }
          }
          )
          .catch(error => console.log('error', error));
      }
    }

    getRoleDetails()

  }, [roleDataById])

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_roleName: Yup.string().required("Role name is required").min(2, `Name can't be less than 2 characters!`),
      iv_level: Yup.mixed().required("Role level is required"),
      iv_status: Yup.mixed().required("Role status is required"),
      iv_show_all_applications_flag: Yup.number().required('Select All Applications flag'),
      iv_assigning_order_no: Yup.string().required("Order No. is required."),
      iv_assigning_authority: Yup.string().required("Order authority is required."),
      iv_assigining_date: Yup.string().required("Order date is required."),
      iv_assigining_order_image: Yup.string().required('Upload order image.')
    }),
    onSubmit: async (values, { resetForm }) => {
      setIsLoadingSpinner(true);
      var formdata = new FormData();
      formdata.append("roleId", roleDataById.id);
      formdata.append("roleName", values.iv_roleName);
      formdata.append("level", values.iv_level);
      formdata.append("status", values.iv_status);
      formdata.append("updatedBy", userId);
      checkedItems.forEach(item => {
        formdata.append("permissions", item)
      })
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;
      formdata.append("showAllApplicationsFlag", values.iv_show_all_applications_flag);
      formdata.append("premAsigningOrderNo", values.iv_assigning_order_no);
      formdata.append("premAsigningOrderAuthority", values.iv_assigning_authority);
      formdata.append("premAsigningOrderDate", values.iv_assigining_date);
      formdata.append("premAsigningOrderImage", orderImageThumbnail);

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "role/UpdateRole", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === '200') {
            // toast.success(result.message)
            setIsLoadingSpinner(false);
            var formdata = new FormData();
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;

            var requestOptions = {
              method: 'POST',
              body: formdata,
              headers: myHeaders,
              redirect: 'follow',
            };

            fetch(cfpBaseUrl + "role/getAllRoles", requestOptions)
              .then(response => response.json())
              .then(result => {
                if (result.status === "200") {
                  navigate('/role-management')
                }
              })
              .catch(error => console.log('error', error));
          }
          else {
            setIsLoadingSpinner(false);
          }
        })
        .catch(error => {
          setIsLoadingSpinner(false);
        });
    }

  });

  function CheckboxItem({ item, onCheck, checkedItems }) {
    const { idt, name, children } = item;

    function handleCheck(event) {
      const isChecked = event.target.checked;
      onCheck(item, isChecked);
    }

    // Determine if this item is checked based on its id
    const isChecked = checkedItems.includes(idt);

    return (
      <Grid container >
        <Grid item sx={item.children != null ? { border: '1px solid lightGrey', borderRadius: '5px', padding: '10px', margin: '5px', backgroundColor: '#EEF1F7' } : { padding: '2px', margin: '2px' }}>
          <Grid container display='flex' justifyContent='space-between'>
            <Grid item xs={2}>
              <input type="checkbox" checked={isChecked} onChange={handleCheck} />
            </Grid>
            <Grid item xs={10}>
              <label style={{ marginLeft: '5px' }}>
                {name}
              </label>
            </Grid>
          </Grid>
          {children && children.length > 0 && (
            <div style={{ marginLeft: '20px', }}>
              {children.map(child => (
                <CheckboxItem key={child.idt} item={child} onCheck={onCheck} checkedItems={checkedItems} />
              ))}
            </div>
          )}

        </Grid>
      </Grid>
    );
  }

  function CheckboxHierarchy({ data }) {

    function handleCheck(item, isChecked) {
      // Update the checked items array
      let newCheckedItems = [...checkedItems];

      // If the item is being checked, add its id to the checked items array
      // and check all its children and grandchildren
      if (isChecked) {
        newCheckedItems.push(item.idt);
        checkChildrenAndGrandchildren(item, newCheckedItems);
      }
      // If the item is being unchecked, remove its id from the checked items array
      // and uncheck all its children and grandchildren
      else {
        newCheckedItems = uncheckChildrenAndGrandchildren(item, newCheckedItems);
        newCheckedItems = newCheckedItems.filter((checkedItem) => checkedItem !== item.idt);
      }
      setCheckedItems(newCheckedItems);
    }

    // Recursive function to check all children and grandchildren of an item
    function checkChildrenAndGrandchildren(item, checkedItems) {
      if (item.children) {
        item.children.forEach((child) => {
          checkedItems.push(child.idt);
          checkChildrenAndGrandchildren(child, checkedItems);
        });
      }
    }

    // Recursive function to uncheck all children and grandchildren of an item
    function uncheckChildrenAndGrandchildren(item, checkedItems) {
      if (item.children) {
        item.children.forEach((child) => {
          checkedItems = uncheckChildrenAndGrandchildren(child, checkedItems);
          checkedItems = checkedItems.filter((checkedItem) => checkedItem !== child.idt);
        });
      }
      return checkedItems;
    }

    return (
      <Grid container display='flex'>
        {
          data.map(rootItem => (
            <Grid item>
              <CheckboxItem key={rootItem.idt} item={rootItem} onCheck={handleCheck} checkedItems={checkedItems} />
            </Grid>
          ))
        }
      </Grid>
    );
  }

  const Status = (event) => {
    event.preventDefault()
    setStatus(event.target.value)
    values.iv_status = event.target.value
  }

  const ApplicationsAppliedLoadFilter = (event) => {
    setApplicationsAppliedLoadFilter(event.target.value)
    values.iv_show_all_applications_flag = event.target.value
  }
  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    console.log("Generated date (YYYY-MM-DD):", formattedDate);
    return formattedDate;
  };
  const today = getTodayDate();
  const minDate = values.iv_assigining_date || today; //
  console.log("Max date:", today, "Min date:", minDate);
  return (
    <>
      <Grid container className='roleUpdate'>
        <Box className='roleUpdateContainer'>
          <h3 className='heading'>
            Role Update Form
          </h3>
          <form className='ncform'>
            <Grid container>
              <Grid item xs={3}>
                <label className='fieldLabel' >Role Name</label>
                <TextField
                  type='text'
                  name="iv_roleName"
                  autoComplete='off'
                  value={values.iv_roleName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  id="iv_roleName"
                  className='textInputField'
                />
                <Box className='from-Error'>
                  {errors.iv_roleName && touched.iv_roleName ? (errors.iv_roleName) : null}
                </Box>
              </Grid>
              <Grid item xs={3}>
                <label className='fieldLabel' >Status</label>
                <FormControl className='form-control' >
                  <RadioGroup
                    className='radio-group'
                    row
                    name="iv_status"
                    defaultValue={status}
                    value={status}
                    onChange={Status}
                  >
                    <FormControlLabel
                      value={1}
                      className='form-control-label'
                      control={<Radio />}
                      label="Active"
                      name='active'
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value={2}
                      className='form-control-label'
                      control={<Radio />}
                      label="Inactive"
                      name='inactive'
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <label className='fieldLabel' >Show All Applications </label>
                <FormControl className='form-control' >
                  <RadioGroup
                    className='radio-group'
                    row
                    name="iv_show_all_applications_flag"
                    defaultValue={values.iv_show_all_applications_flag}
                    value={values.iv_show_all_applications_flag}
                    onChange={ApplicationsAppliedLoadFilter}
                  >
                    <FormControlLabel
                      value={1}
                      className='form-control-label'
                      control={<Radio />}
                      label="Yes"
                      name='yes'
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value={0}
                      className='form-control-label'
                      control={<Radio />}
                      label="No"
                      name='no'
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <label className='fieldLabel' >Level</label>
                <Select
                  autoWidth={false}
                  value={values.iv_level}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  displayEmpty
                  name="iv_level"
                  size='small'
                  id="iv_level"
                  className='dropdownList'
                >
                  <MenuItem value=''>Select Level</MenuItem>
                  {
                    technicalLevels.map(item => <MenuItem value={item.value}>{item.label}</MenuItem>)
                  }
                </Select>
              </Grid>
              <Grid item xs={3}>
                <label className='fieldLabel' >Order No.</label>
                <TextField
                  type='text'
                  name="iv_assigning_order_no"
                  autoComplete='off'
                  value={values.iv_assigning_order_no}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  id="iv_assigning_order_no"
                  className='textInputField'
                />
                <Box className='from-Error'>
                  {errors.iv_assigning_order_no && touched.iv_assigning_order_no ? (errors.iv_assigning_order_no) : null}
                </Box>
              </Grid>
              <Grid item xs={3}>
                <label className='fieldLabel' >Order Authority</label>
                <TextField
                  type='text'
                  name="iv_assigning_authority"
                  autoComplete='off'
                  value={values.iv_assigning_authority}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  id="iv_assigning_authority"
                  className='textInputField'
                />
                <Box className='from-Error'>
                  {errors.iv_assigning_authority && touched.iv_assigning_authority ? (errors.iv_assigning_authority) : null}
                </Box>
              </Grid>
              <Grid item xs={3}>
                <label className='fieldLabel' >Order Date</label>
                <input
                  type="date"
                  name="iv_assigining_date"
                  value={values.iv_assigining_date}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  id="iv_assigining_date"
                  className="dateInputField"
                  max={today}
                  min={minDate}
                />
                <Box className='from-Error'>
                  {errors.iv_assigining_date && touched.iv_assigining_date ? (errors.iv_assigining_date) : null}
                </Box>
              </Grid>
              <Grid item xs={3}>
                <label className='fieldLabel' >Order Image</label>
                <Box className='from-Error'>
                  {errors.iv_assigining_order_image && touched.iv_assigining_order_image ? (errors.iv_assigining_order_image) : null}
                </Box>
                <Grid item lg="2">
                  {orderImage ? (
                    <>
                      <Button
                        component="label"
                        startIcon={
                          <CloseIcon
                            className="button-with-image"
                            onClick={() => {
                              setOrderImage("");
                            }}
                          />
                        }
                      >
                        {orderImageThumbnail &&
                          isImage(orderImage) ? (
                          <div className="btn-div">
                            <img
                              src={orderImageThumbnail}
                              alt="Order Image"
                              width="80"
                            />
                          </div>
                        ) : (
                          <span>
                            {isPdf(orderImage) ? (
                              <div className="btn-div">
                                <img src={pdfIcon} alt="PDF" width="80" />
                                {/* <p>{orderImageFileName}</p> */}
                              </div>
                            ) : (
                              "Other file type"
                            )}
                          </span>
                        )}
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        variant="outlined"
                        component="label"
                        startIcon={<FileUploadOutlinedIcon />}
                        className="btn"
                      >
                        Upload
                        <input
                          hidden
                          accept={documentExtensions}
                          id="iv_assigining_order_image"
                          name="iv_assigining_order_image"
                          type="file"
                          onChange={OrderImage}
                        />
                      </Button>
                      <Box className='from-Error'>
                        {orderImage == '' ?
                          orderImageError : null
                        }
                      </Box>
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <label className='fieldLabel'>
              Permissions
            </label>
            <div style={{ marginLeft: '10px' }}>
              <CheckboxHierarchy data={sortedPermissions} />
            </div>
            <Box sx={{ marginTop: '1%' }}>
              <Button sx={{ width: '30%' }} variant="contained" color='success' size='medium' onClick={handleSubmit} disabled={isLoadingSpinner}>
                {isLoadingSpinner ? (
                  <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                  </Box>
                ) : (
                  'Submit'
                )}
              </Button>
              < ToastContainer autoClose={5000} style={{ width: '50%' }} theme="colored" />
              < ToastContainer autoClose={5000} style={{ width: '50%' }} theme="colored" />
            </Box>
          </form >
        </Box >
      </Grid >
      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop >
    </>
  )
}

export default RoleUpdateForm;